import { render, staticRenderFns } from "./EuroValue.vue?vue&type=template&id=21de259e&scoped=true&"
import script from "./EuroValue.vue?vue&type=script&lang=js&"
export * from "./EuroValue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21de259e",
  null
  
)

export default component.exports